import {
  SelectRegistrationEntity,
  SelectRegistrationResponse,
  SelectRegistrationsResponse,
} from 'src/types'

export const SelectRegistrationTranslator = {
  toEntity: (response: SelectRegistrationResponse): SelectRegistrationEntity => {
    return {
      id: `${response.id}`,
      name: response.name,
      priority: response.priority,
      selectMasterId: `${response.selectMasterId}`,
      registeredSelectOption: response.registeredSelectOption
        ? {
            id: `${response.registeredSelectOption.id}`,
            name: response.registeredSelectOption.name,
            isPaid: response.registeredSelectOption.isPaid,
            child: response.registeredSelectOption.child
              ? {
                  id: `${response.registeredSelectOption.child.id}`,
                  name: response.registeredSelectOption.child.name,
                  isPaid: response.registeredSelectOption.child.isPaid,
                }
              : undefined,
          }
        : undefined,
    }
  },

  toEntities: (response: SelectRegistrationsResponse): SelectRegistrationEntity[] => {
    return response.selectRegistrations.map(r => SelectRegistrationTranslator.toEntity(r))
  },
} as const
